import { createContext, useContext } from 'react';

import type { Source } from '~context/media-content/types';

export const MediaContentContext = createContext<{
	open: (source: Source[], currentIndex: number) => void;
	close: () => void;
	update: (source: Source[]) => void;
	openedId: number | null;
}>({
	openedId: null,
	close: () => undefined,
	open: () => undefined,
	update: () => undefined,
});

export const useMediaContentContext = () => {
	const context = useContext(MediaContentContext);
	if (!context) {
		throw Error('MediaContent context no context Provider');
	}
	return context;
};
